import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCurrentUserSilosQuery } from './Silos.generated';
import { CreateOrEditSiloForm, SilosTable } from './components';
import { Button, PortalModal } from '@web/utils/src';
import { Silo } from '@/types';

const MyFarmPage = () => {
  const { t } = useTranslation();
  const [{ data }] = useGetCurrentUserSilosQuery();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [siloToEdit, setSiloToEdit] = useState<Silo | undefined>(undefined);

  const handleCreateNewSilo = () => {
    setSiloToEdit(undefined);
    setIsEditOpen(true);
  };
  const handleEdit = (silo: Silo) => {
    setSiloToEdit(silo);
    setIsEditOpen(true);
  };

  return (
    <>
      <PortalModal isOpen={isEditOpen} setIsOpen={setIsEditOpen}>
        <CreateOrEditSiloForm
          isEdit={!!siloToEdit}
          silo={siloToEdit}
          setIsOpen={setIsEditOpen}
        />
      </PortalModal>
      <div className="py-6-0">
        <div className="">
          <p className="text-3-2 font-bd mb-2-0">{t('farm.title')}</p>
        </div>
        <div>
          <div className="flex justify-between items-center">
            <p className="text-2-0 font-bd mb-2-0">{t('farm.silos.title')}</p>
            <div className="flex gap-x-2-0">
              <Button onClick={handleCreateNewSilo}>
                {t('farm.silos.add_new_silo')}
              </Button>
            </div>
          </div>
          {data?.currentUser?.silos && (
            <SilosTable silos={data?.currentUser.silos} handleEdit={handleEdit} />
          )}
        </div>
      </div>
    </>
  );
};

export default MyFarmPage;
